import { Outlet } from 'react-router-dom';
import AppLayout from '@/components/Layouts/AppLayout';

/**
 * Envuelve las pantallas de presupuestos independientes con el layout principal
 * (sidebar, cabecera y footer), igual que el resto de los módulos.
 */
export function PresupuestosLayout() {
  return (
    <AppLayout prevButtonVisible={false}>
      <Outlet />
    </AppLayout>
  );
}
